import { Select, MenuItem, FormControl, InputLabel } from '@mui/material';
import { EPartnerType } from '../../models/partner.model';
import _ from 'lodash';

type Props = {
  value: EPartnerType;
  onChange?: (value: EPartnerType) => void;
  margin?: 'none' | 'dense' | 'normal' | undefined;
};

const PartnerTypeSelect = (props: Props) => {
  const dropdownItems = Object.values(EPartnerType);

  return (
    <FormControl fullWidth margin={props.margin}>
      <InputLabel>Type</InputLabel>
      <Select
        size="small"
        label="Type"
        value={props.value}
        onChange={(e) => {
          const item = dropdownItems.find((i) => i === e.target.value);
          if (item) {
            props.onChange?.(item);
          }
        }} // Handle select change here
        displayEmpty
        renderValue={(selected) => {
          return _.capitalize(_.words(selected).join(' '));
        }}
      >
        {dropdownItems.map((item) => (
          <MenuItem key={item} value={item}>
            {_.capitalize(_.words(item).join(' '))}
          </MenuItem>
        ))}
      </Select>
    </FormControl>
  );
};

export default PartnerTypeSelect;
